import innerHeight from 'ios-inner-height';

// Fix for iOS Safari 100vh weirdness.
window.addEventListener("DOMContentLoaded", () => {
  const root = document.documentElement;
  const headerHeight = document.getElementById('shopify-section-header').offsetHeight;


  const ivh = innerHeight() * 0.01;
  const vh = window.innerHeight * 0.01
  root.style.setProperty('--ivh', ivh + "px");
  root.style.setProperty('--vh', vh + "px");
  root.style.setProperty('--header-height', headerHeight + 'px')
});

import NutritionTabs from './components/nutrition-tabs';

const TabsList = new NutritionTabs();
